/**
Project: Voice Panel (c)
Title: Error Page
Description: Error Page to be displayed when errors occurred from server API
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import {
  Image,
  Flex,
  Text,
  Button,
  Tooltip,
  ClipboardCopiedToIcon,
} from "@fluentui/react-northstar";
import SippioVoicePanelLogo from "../../../assets/images/SIPPIO-VoicePanel-Logo.png";
import IntlUtil from "../helpers/intl-util";
import { AppURLProps } from "../settings/app-urls";
import { AppPageTitle } from "../components/app-page-title";
import { connect } from "react-redux";
import { getAppInsights } from "../settings/azure-insights-config";
import { CopyToClipboard } from "react-copy-to-clipboard";

class ErrorPage extends Component {
  _intl_ns_common = "common";
  _intl_ns_error = "error";
  _azureInsights = getAppInsights();

  constructor(props) {
    super(props);
    this.state = {
      isCopied: false,
      pageURL: "",
      method: "",
      statusCode: "",
      errMessage: "",
      endPoint: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const queryParams = this.props.location?.state || {};
    this.setState({
      pageURL: queryParams.pageURL,
      method: queryParams.method,
      statusCode: queryParams.statusCode,
      errMessage: queryParams.errMessage,
      endPoint: queryParams.endPoint,
    });
  }
  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  userProfile = () => {
    const subscriberIdentity = this.props.subscriberIdentity;
    const subscriberAccount = this.props.subscriberAccount;
    let identityProfile = "";
    if (
      subscriberIdentity &&
      subscriberIdentity?.userEmail &&
      subscriberAccount &&
      subscriberAccount?.accountNumber
    ) {
      identityProfile = (
        <>
          <Flex gap="gap.smaller">
            <Text size="medium">
              {IntlUtil.getText(this._intl_ns_error, "content.user")}:
            </Text>
            <Text size="medium">{subscriberIdentity?.userEmail}</Text>
          </Flex>
          <Flex className="m-t-5" gap="gap.smaller">
            <Text size="medium">
              {IntlUtil.getText(this._intl_ns_error, "content.accountId")}
            </Text>
            <Text size="medium">{subscriberAccount?.accountNumber}</Text>
          </Flex>
        </>
      );
    }
    return identityProfile;
  };

  copyErrorDetails() {
    let errorDetails = [
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.user"),
        value: this.props.subscriberIdentity?.userEmail,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.accountId"),
        value: this.props.subscriberAccount?.accountNumber,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.pageURL"),
        value: window.location.origin + this.state.pageURL,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.apiEndPoint"),
        value: this.state.endPoint,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.apiMethod"),
        value: this.state.method,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.apiStatusCode"),
        value: this.state.statusCode,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.errorMessage"),
        value: this.state.errMessage,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.userId"),
        value: this._azureInsights?.context?.user?.id,
      },
      {
        name: IntlUtil.getText(this._intl_ns_error, "content.sessionId"),
        value:
          this._azureInsights?.context?.sessionManager?.automaticSession?.id,
      },
    ];
    return errorDetails;
  }

  onCopyText = () => {
    this.setState({ isCopied: true });
    setTimeout(() => {
      this.setState({ isCopied: false });
    }, 1000);
  };

  renderErrorDetails() {
    return (
      <Flex column gap="gap.small" className="error-details-box">
        <Flex column>
          {this.userProfile()}
          {/* {new URLSearchParams(this.props.history.location.search).get("pageURL") ? */}
          <Flex className="m-t-5" gap="gap.smaller">
            <Text size="medium">
              {IntlUtil.getText(this._intl_ns_error, "content.pageURL")}:
            </Text>
            <Text size="medium">
              {" "}
              {this.state.pageURL
                ? window.location.origin + this.state.pageURL
                : window.location.origin + this.props.history.location.pathname}
            </Text>
          </Flex>
          {this.state.endPoint ? (
            <Flex className="m-t-5" gap="gap.smaller">
              <Text size="medium">
                {IntlUtil.getText(this._intl_ns_error, "content.apiEndPoint")}
              </Text>
              <Text>{this.state.endPoint}</Text>
            </Flex>
          ) : null}
          {this.state.method ? (
            <Flex className="m-t-5" gap="gap.smaller">
              <Text size="medium">
                {IntlUtil.getText(this._intl_ns_error, "content.apiMethod")}:
              </Text>
              <Text>{this.state.method}</Text>
            </Flex>
          ) : null}
          {this.state.statusCode ? (
            <Flex className="m-t-5" gap="gap.smaller">
              <Text size="medium">
                {IntlUtil.getText(this._intl_ns_error, "content.apiStatusCode")}
                :
              </Text>
              <Text>{this.state.statusCode}</Text>
            </Flex>
          ) : null}
          {this.state.errMessage ? (
            <Flex className="m-t-5" gap="gap.smaller">
              <Text size="medium">
                {IntlUtil.getText(this._intl_ns_error, "content.errorMessage")}:
              </Text>
              <Text>{this.state.errMessage}</Text>
            </Flex>
          ) : null}
          {this._azureInsights?.context?.user?.id ? (
            <Flex className="m-t-5" gap="gap.smaller">
              <Text size="medium">
                {IntlUtil.getText(this._intl_ns_error, "content.userId")}:
              </Text>
              <Text>{this._azureInsights?.context?.user?.id}</Text>
            </Flex>
          ) : null}
          {this._azureInsights?.context?.sessionManager?.automaticSession
            ?.id ? (
            <Flex className="m-t-5" gap="gap.smaller">
              <Text size="medium">
                {IntlUtil.getText(this._intl_ns_error, "content.sessionId")}:
              </Text>
              <Text size="medium">
                {
                  this._azureInsights?.context?.sessionManager?.automaticSession
                    ?.id
                }
              </Text>
            </Flex>
          ) : null}
        </Flex>
      </Flex>
    );
  }

  render() {
    return (
      <>
        <AppPageTitle
          pageTitle={IntlUtil.getText(
            this._intl_ns_common,
            "title.serverError"
          )}
        />
        <div id="error-page">
          <header className="error-page-header">
            <Image
              src={SippioVoicePanelLogo}
              alt={IntlUtil.getText(
                this._intl_ns_common,
                "content.voicePanelBySippio"
              )}
              title={IntlUtil.getText(
                this._intl_ns_common,
                "content.voicePanelBySippio"
              )}
            />
          </header>
          <div className="error-page-content">
            <Flex column className="error-page-segment">
              <Flex className="m-b-20">
                <Text error size="large" className="text-bold text-uppercase">
                  Error
                </Text>
              </Flex>
              <Flex className="m-b-15">
                <Text size="medium">
                  An error has occurred, please try again later.
                </Text>
              </Flex>
              {this.renderErrorDetails()}
              <Flex>
                <Tooltip
                  content={
                    this.state.isCopied === true ? (
                      <Text className="vpa-page-tooltip">
                        Copied to clipboard
                      </Text>
                    ) : (
                      <Text className="vpa-page-tooltip">
                        Copy to clipboard
                      </Text>
                    )
                  }
                >
                  <CopyToClipboard
                    text={this.copyErrorDetails()
                      .map((item) => {
                        return item.value
                          ? `${item.name}: ${item.value}`
                          : null;
                      })
                      .filter((removeNull) => {
                        return removeNull != null;
                      })
                      .join("\n")}
                    onCopy={() => this.onCopyText()}
                  >
                    <Button
                      className="text-fc-primary"
                      icon={<ClipboardCopiedToIcon />}
                      text
                      content="Copy Error Details"
                    />
                  </CopyToClipboard>
                </Tooltip>
              </Flex>
              <Flex gap="gap.medium" className="m-b-20 m-t-30">
                <Button
                  size="medium"
                  onClick={() => this.props.history.push(AppURLProps.home)}
                  content="Go to Home Page"
                ></Button>
                <Button
                  size="medium"
                  onClick={() => this.props.history.push(AppURLProps.signin)}
                  content="Go to Sign in Page"
                ></Button>
              </Flex>
            </Flex>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  subscriberIdentity: state.subscriberStore.subscriberIdentity,
  subscriberAccount: state.subscriberStore.subscriberAccount,
});
const mapActionToProps = {};

export default connect(mapStateToProps, mapActionToProps)(ErrorPage);
